import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-tutorial',
  imports: [MatButtonModule],
  templateUrl: './tutorial.component.html',
  styleUrl: './tutorial.component.scss',
})
export class TutorialComponent {
  images: string[];
  imageText: string[];

  currentImageIndex: number = 0;

  constructor(public dialogRef: MatDialogRef<TutorialComponent>) {
    this.images = [
      'assets/tutorial/metrics.png',
      'assets/tutorial/tabs.png',
      'assets/tutorial/order_button.png',
      'assets/tutorial/help_button.png',
    ];

    this.imageText = [
      'Your relationship metrics with us are shown on the top',
      'View fulfilled orders, orders in progress, live quotes and live enquiries in these sections',
      'Click here to view details of your order',
      'To revisit this tutorial, click here',
    ];
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onPrevImage(): void {
    if (this.currentImageIndex == 0) {
      return;
    }

    this.currentImageIndex -= 1;
  }

  onNextImage(): void {
    if (this.currentImageIndex == this.images.length - 1) {
      return;
    }

    this.currentImageIndex += 1;
  }
}
